<template>
  <div :class="'recommendation-list' + (showButton ? '' : ' recommendation-list_child')">
    <div
      v-for="item in recommendations" :key="item.id"
      class="item"
      @click="$emit('select-recommendation', item.id)">

      <img
        v-if="item.image"
        :src="item.image.url" />

      <div class="title">{{item.title}}</div>

      <div class="button" v-if="showButton">
        <i class="fas fa-chevron-right"></i>
      </div>

      <div class="button-bg" v-if="showButton"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RecommendationList',

    props: ['recommendations', 'showButton'],

    data() {
      return {};
    },

    computed: {
    },

    methods: {
    },
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .recommendation-list {
    padding: 0;

    .page-title {
      position: relative;
      padding: 10px 20px;
      text-align: left;

      i {
        position: absolute;
        top: 10px;
        right: 15px;
        width: 20px;
        height: 20px;
        font-size: 20px;
        color: $primary;
      }
    }

    .item {
      position: relative;
      min-height: 100px;
      margin: 0 0 2px;
      padding: 0;
      font-weight: bold;
      color: $white;
      background-color: $primary;

      img {
        width: 100%;
      }

      .title {
        z-index: 101;
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 20px;
        margin-top: -10px;
        padding-left: 50px;
      }

      .button {
        z-index: 101;
        position: absolute;
        top: 50%;
        right: 15px;
        height: 20px;
        margin-top: -20px;
        font-size: 24px;
        color: $primary;
      }

      .button-bg {
        z-index: 100;
        position: absolute;
        top: 0;
        right: 0;
        width: 50px;
        height: 100%;
        background-color: $white;
        opacity: 0.3;
      }
    }

    &.recommendation-list_child {
      .title {
        padding: 0;
        text-align: center;
      }
    }
  }
</style>
